import * as React from 'react';
import { getAllUpcomingAuctionsUrl, getAuctionResultsUrl, getTodayUrl } from '@/utils/urls';
import { useDispatch, useSelector } from 'react-redux';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faFire } from '@fortawesome/pro-regular-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getBaseUrl } from '../../../redux/modules/config';
import { getWhiteLabelLogo } from '../../../redux/modules/whiteLabel';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import SlideMenu from '@liveauctioneers/caterwaul-components/lib/SlideMenu/SlideMenu';
import styled from 'styled-components';
import { trackPriceResultsClick } from '../../../redux/modules/analytics';

const MobileNavigation = () => {
    const dispatch = useDispatch();
    const baseUrl = useSelector(getBaseUrl);
    const logo = useSelector(getWhiteLabelLogo);

    const priceResultsClick = React.useCallback(() => dispatch(trackPriceResultsClick()), [dispatch]);

    return (
        <StyledMobileNavigationSlideMenu header={Boolean(logo) && <StyledMobileNavLogo alt="logo" src={logo} />}>
            <StyledLink route to={getTodayUrl()}>
                <StyledIcon icon={faFire} />
                <FormattedMessage id="trending_auctions" />
            </StyledLink>
            <StyledLink route to={getAllUpcomingAuctionsUrl()}>
                <StyledIcon icon={faCalendarAlt} />
                <FormattedMessage id="auction_calendar" />
            </StyledLink>
            <StyledLink route to="/find-auctions-near-me">
                <FormattedMessage id="auctions_near_me" />
            </StyledLink>
            <StyledLink onClick={priceResultsClick} route to={getAuctionResultsUrl()}>
                <FormattedMessage id="price_results" />
            </StyledLink>
            <StyledDivider />
            <StyledCategories>
                <FormattedMessage id="navigation.categories" />
            </StyledCategories>
            <StyledLink route to="/c/art/1/">
                <FormattedMessage id="navigation.art" />
            </StyledLink>
            <StyledLink route to="/c/jewelry/6/">
                <FormattedMessage id="navigation.jewelry" />
            </StyledLink>
            <StyledLink route to="/c/asian/158/">
                <FormattedMessage id="navigation.asian_antiques" />
            </StyledLink>
            <StyledLink route to="/c/furniture/4/">
                <FormattedMessage id="navigation.furniture" />
            </StyledLink>
            <StyledLink route to="/c/collectibles/2/">
                <FormattedMessage id="navigation.collectibles" />
            </StyledLink>
            <StyledLink route to="/c/coins-currency-stamps/24/">
                <FormattedMessage id="navigation.coins" />
            </StyledLink>
            <StyledLink route to="/c/home-garden/5/">
                <FormattedMessage id="navigation.home_and_garden" />
            </StyledLink>
            <StyledLink route to="/c/fashion/3/">
                <FormattedMessage id="navigation.fashion" />
            </StyledLink>
            <StyledDivider />
            <StyledLink rel="noopener" target="_blank" to="https://help.liveauctioneers.com/">
                <FormattedMessage id="help" />
            </StyledLink>
            <StyledLink target="_blank" to={`${baseUrl}/news/`}>
                <FormattedMessage id="news" />
            </StyledLink>
            <StyledLink route to="/consignments">
                <FormattedMessage id="consign" />
            </StyledLink>
        </StyledMobileNavigationSlideMenu>
    );
};

export default React.memo(MobileNavigation);

const StyledMobileNavigationSlideMenu = styled(SlideMenu)`
    display: block;

    & > div > svg {
        color: ${({ theme }) => theme.colors.grey100};
        height: 24px;
        width: 21px;
        vertical-align: -3px;
    }
`;

const StyledMobileNavLogo = styled.img`
    width: 126px;
    height: 16.03px;
    margin: 21px 10px 15px 20px;
`;

const StyledLink = styled(Link)`
    && {
        display: block;
        font-family: ${({ theme }) => theme.typography.fontSecondary};
        font-size: 15px;
        color: ${({ theme }) => theme.colors.grey100};
        text-decoration: none;
        padding: 10px 10px 4px 20px;

        &:last-child {
            padding: 10px 10px 10px 20px;
        }
    }
`;

const StyledIcon = styled(FontAwesomeIcon)`
    margin-right: 10px;
`;

const StyledDivider = styled.div`
    margin: 16px 24px 16px 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
`;

const StyledCategories = styled.div`
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    color: ${({ theme }) => theme.colors.black};
    padding: 10px 10px 5px 20px;
    font-size: 11px;
    letter-spacing: 1px;
`;
